var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timesheet-section" },
    [
      _vm.layoutData.divider
        ? _c("hr", {
            staticStyle: { "border-top-color": "#ddd", margin: "8px 0" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldType == "group" || _vm.fieldType == "root"
        ? _c("timesheet-group-basic", {
            attrs: { layout: _vm.layoutData },
            on: { change: _vm.onChange }
          })
        : _vm.fieldType == "material"
        ? _c("timesheet-group-material", {
            attrs: { layout: _vm.layoutData },
            on: { change: _vm.onChange }
          })
        : _vm.fieldType == "activity"
        ? _c("timesheet-group-activity", {
            attrs: { layout: _vm.layoutData },
            on: { change: _vm.onChange }
          })
        : _vm.fieldType == "collapsible_group"
        ? _c("timesheet-group-collapsible", {
            attrs: { layout: _vm.layoutData },
            on: { change: _vm.onChange }
          })
        : _vm.fieldType == "tabs"
        ? _c("timesheet-group-tabs", {
            attrs: { layout: _vm.layoutData },
            on: { change: _vm.onChange }
          })
        : _vm.fieldType == "field_selector"
        ? _c("timesheet-group-field-selector", {
            attrs: { layout: _vm.layoutData },
            on: { change: _vm.onChange }
          })
        : _c(
            "div",
            [
              _c("timesheet-field", {
                attrs: {
                  layout: _vm.layoutData,
                  errors: _vm.layoutData.errors,
                  value: _vm.layoutData.value
                },
                on: { change: _vm.onChange }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }